import React from "react";
/* eslint-disable */
import {
  Box, TableBody, TableCell, TableContainer, TableHead, TableRow, Table,
} from '@material-ui/core';


export default class ComponentToPrint extends React.Component {

  render() {
    const productData = this.props.productList;
    const data = this.props.searchData;

    return (
      <div style={{ paddingLeft: '10px', paddingRight: '10px' }}>
        <div>&nbsp;</div>
        <h3><center><u>Farmer Collection Center Wise Transaction Report </u></center></h3>
        <div>&nbsp;</div>
        {/* <Grid style={{ padding: '20px' }} container spacing={2}>
          <Grid md={2} xs={2}>
            <h4>Group:</h4>
          </Grid>
          <br />
          <Grid md={10} xs={10}>
            {data.groupID}
          </Grid>
          <br />
          <Grid md={2} xs={2}>
            <h4>Fresh Collection Center:  </h4>
          </Grid>
          <Grid md={10} xs={10}>
            {data.operationEntityID}
          </Grid>
        </Grid> */}
        <div>&nbsp;</div>
        <Box minWidth={1050}>
          <TableContainer style={{ marginLeft: '5px' }}>
            <Table aria-label="caption table">
              <TableHead>
                <TableRow>
                  <TableCell align={'left'}>Farmer Name</TableCell>
                  <TableCell align={'left'}>Supplier Code</TableCell>
                  <TableCell align={'left'}>Fresh Collection Center</TableCell>
                  <TableCell align={'left'}>Product Name</TableCell>
                  <TableCell align={'left'}>Date</TableCell>
                  <TableCell align={'right'}>Allocated Quantity</TableCell>
                  <TableCell align={'right'}>Supplied Quantity</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {productData.map((data, index) => (
                  <TableRow key={index}>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.firstName}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.supplierCode ? data.supplierCode : ' - '}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.factoryName}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.productName}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {new Date(data.orderDate).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', minimumIntegerDigits: 2 })}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.allocatedQuantity.toFixed(2)}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.quantity.toFixed(2)}
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow style={{ backgroundColor: '#f5f5f5', fontWeight: 'bold'}}>
                  <TableCell colSpan={5} align="right" style={{ fontWeight: 'bold', borderBottom: "none" }}>
                    <strong>Total:</strong>
                  </TableCell>
                  <TableCell align={'right'} style={{ fontWeight: 'bold', borderBottom: "none" }}>
                    {productData.reduce((sum, row) => sum + row.allocatedQuantity, 0).toFixed(2)}
                  </TableCell>
                  <TableCell align={'right'} style={{ fontWeight: 'bold', borderBottom: "none" }}>
                    {productData.reduce((sum, row) => sum + row.quantity, 0).toFixed(2)}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </div>

    );
  }
}
